
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/stay-at-giraffe-manor",
      function () {
        return require("private-next-pages/landing/stay-at-giraffe-manor.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/stay-at-giraffe-manor"])
      });
    }
  